import React from "react"

import Navlink from "./Navlink"

export default class Navbar extends React.Component
{
    render()
    {
        const shouldSee = this.props.shouldSee

        return (
            <nav className="navbar navbar-expand-lg navbar-light bg-light" style={{display: shouldSee}}>
                <div className="container">
                    <div className="navbar-brand">
                        <img className="site-logo" alt="Logo" src="https://wiltoscdn.nyc3.digitaloceanspaces.com/images/wiltos.svg" />
                    </div>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#nav" aria-controls="nav">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="nav">
                        <ul className="navbar-nav ml-auto">
                            <Navlink link="/" text="Home" />
                            <Navlink link="/creations" text="Creations" />
                            <Navlink link="/changelog" text="Changelogs" />
                            <Navlink link="https://support.wiltostech.com" text="Support" />
                            <Navlink link="/about" text="About Us" />
                            <Navlink link="/contact" text="Contact Us" />
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }
}
